import { signOut } from '@creditsights/api-ui-web';

const Logout = (): null => {
  signOut();
  return null;
};

export default Logout;
